// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageTakeoffTableQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TakeoffLineItemFilter>;
  subFilter?: Types.InputMaybe<Types.TakeoffLineItemFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Array<Types.TakeoffLineItemOrder> | Types.TakeoffLineItemOrder>;
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageTakeoffTableQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, isPlaceholderMaterial: boolean, quantity?: number | null | undefined, costType: Types.CostType, changeType: string, action: { __typename?: 'TakeoffLineItemActionDetail', code: Types.TakeoffLineItemAction, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, number: string }, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string } }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } }>, listing: { __typename?: 'MaterialListing', id: string, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType } } } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean, abbreviation: string }, location: { __typename?: 'Location', displayLocationPath: string, id: string, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayCode: string, active: boolean, displayName: string }>, task?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, canDuplicate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string }, task?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined }>, groupTotals: Array<{ __typename?: 'TakeoffLineItemGroupTotal', groupId: string, tlisInGroup: number, tliIdsInGroup: Array<string>, activeTliIdsInGroup: Array<string>, displayName: string, materialsInGroup: number, tasksInGroup: number }> } };

export type PlanPackageTakeoffTable_ItemsFragment = { __typename?: 'TakeoffLineItem', id: string, name: string, isPlaceholderMaterial: boolean, quantity?: number | null | undefined, costType: Types.CostType, changeType: string, action: { __typename?: 'TakeoffLineItemActionDetail', code: Types.TakeoffLineItemAction, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, number: string }, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string } }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } }>, listing: { __typename?: 'MaterialListing', id: string, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType } } } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean, abbreviation: string }, location: { __typename?: 'Location', displayLocationPath: string, id: string, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayCode: string, active: boolean, displayName: string }>, task?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, canDuplicate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string }, task?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined };

export type PlanPackageTakeoffTable_PreviousTlivFragment = { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string }, task?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export type PlanPackageTakeoffTable_GroupTotalsFragment = { __typename?: 'TakeoffLineItemGroupTotal', groupId: string, tlisInGroup: number, tliIdsInGroup: Array<string>, activeTliIdsInGroup: Array<string>, displayName: string, materialsInGroup: number, tasksInGroup: number };

export const PlanPackageTakeoffTable_PreviousTlivFragmentDoc = gql`
    fragment PlanPackageTakeoffTable_PreviousTliv on TakeoffLineItemVersion {
  id
  quantity
  unitOfMeasure {
    id
  }
  materialVariant {
    id
  }
  location {
    id
  }
  task {
    id
  }
  options {
    id
  }
}
    `;
export const PlanPackageTakeoffTable_ItemsFragmentDoc = gql`
    fragment PlanPackageTakeoffTable_Items on TakeoffLineItem {
  id
  name
  isPlaceholderMaterial
  action {
    code
    name
  }
  item {
    id
    name
    fullCode
    costCode {
      id
      displayName
      number
    }
    designPackageLocation {
      code
      name
    }
  }
  materialVariant {
    id
    code
    materialAttributeValues {
      id
      textValue
      dimension {
        id
        name
        unitOfMeasure {
          id
          abbreviation
        }
      }
    }
  }
  quantity
  unitOfMeasure {
    id
    name
    useQuantity
    abbreviation
  }
  location {
    ...Named
    displayLocationPath
  }
  options {
    id
    name
    displayCode
    active
    displayName
  }
  task {
    ...Named
  }
  materialVariant {
    id
    listing {
      id
      type {
        code
      }
    }
  }
  costType
  canDuplicate {
    ...PotentialOperationDetails
  }
  changeType
  previous {
    ...PlanPackageTakeoffTable_PreviousTliv
  }
}
    ${NamedFragmentDoc}
${PotentialOperationDetailsFragmentDoc}
${PlanPackageTakeoffTable_PreviousTlivFragmentDoc}`;
export const PlanPackageTakeoffTable_GroupTotalsFragmentDoc = gql`
    fragment PlanPackageTakeoffTable_GroupTotals on TakeoffLineItemGroupTotal {
  groupId
  tlisInGroup
  tliIdsInGroup
  activeTliIdsInGroup
  displayName
  materialsInGroup
  tasksInGroup
}
    `;
export const PlanPackageTakeoffTableDocument = gql`
    query PlanPackageTakeoffTable($filter: TakeoffLineItemFilter, $subFilter: TakeoffLineItemFilter, $first: Int, $offset: Int, $order: [TakeoffLineItemOrder!], $versionId: ID!) {
  takeoffLineItemsPage(
    versionId: $versionId
    filter: $filter
    subFilter: $subFilter
    first: $first
    offset: $offset
    order: $order
  ) {
    items {
      ...PlanPackageTakeoffTable_Items
    }
    groupTotals {
      ...PlanPackageTakeoffTable_GroupTotals
    }
  }
}
    ${PlanPackageTakeoffTable_ItemsFragmentDoc}
${PlanPackageTakeoffTable_GroupTotalsFragmentDoc}`;

/**
 * __usePlanPackageTakeoffTableQuery__
 *
 * To run a query within a React component, call `usePlanPackageTakeoffTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageTakeoffTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageTakeoffTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      subFilter: // value for 'subFilter'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageTakeoffTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables> & ({ variables: PlanPackageTakeoffTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>(PlanPackageTakeoffTableDocument, options);
      }
export function usePlanPackageTakeoffTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>(PlanPackageTakeoffTableDocument, options);
        }
// @ts-ignore
export function usePlanPackageTakeoffTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>;
export function usePlanPackageTakeoffTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageTakeoffTableQuery | undefined, PlanPackageTakeoffTableQueryVariables>;
export function usePlanPackageTakeoffTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>(PlanPackageTakeoffTableDocument, options);
        }
export type PlanPackageTakeoffTableQueryHookResult = ReturnType<typeof usePlanPackageTakeoffTableQuery>;
export type PlanPackageTakeoffTableLazyQueryHookResult = ReturnType<typeof usePlanPackageTakeoffTableLazyQuery>;
export type PlanPackageTakeoffTableSuspenseQueryHookResult = ReturnType<typeof usePlanPackageTakeoffTableSuspenseQuery>;
export type PlanPackageTakeoffTableQueryResult = ApolloReactCommon.QueryResult<PlanPackageTakeoffTableQuery, PlanPackageTakeoffTableQueryVariables>;